export default "__VITE_ASSET__CCD8jRWF__"